import useSubscriptionPlan from './useSubscriptionPlan';

export default function useIsCommunityPlan(): boolean | undefined {
  const plan = useSubscriptionPlan();
  return plan ? plan.type === 'community' : undefined;
}
